import React, { useState } from "react"
import 'whatwg-fetch'
import pageStyles from "../components/page.module.css"
import indexStyles from "./index.module.css"
import buttonStyles from "../styles/buttons.module.css"
import Page from "../components/page"
import Team from "../components/team"
import { graphql } from "gatsby"
import ModalVideo from "react-modal-video"
import "react-modal-video/css/modal-video.min.css"
import Img from "gatsby-image/index"
import { Link } from "gatsby"
import useDeviceDetect from "../utils/useDeviceDetect"


export default function Home({ location, data }) {
  const [videoVisible, setVideoVisible] = useState(false)

  const { isMobile } = useDeviceDetect();

  return (
    <Page title={"PhotoTailors – Wedding Photo Albums and Photobooks"} location={location}>
      <div className={pageStyles.sectionWrapper}>
        <div className={pageStyles.section}>
          <div className={indexStyles.teamsSection}>
            <Team
              title='Wedding albums'
              description='perfect for your cherished memories'
              link='/albums/about/'
              data={data}
              image={"albumsTeam"}
              isMobile={isMobile}
            />

            <Team
              title='Guest books'
              description='personalized lay flat'
              link='/guest-books/about/'
              data={data}
              image={"guestbooksTeam"}
              isMobile={isMobile}
            />

            <Team
              title='Children albums'
              description='surprise your loved ones'
              link='/children-albums/about/'
              data={data}
              image={"childrenTeam"}
              isMobile={isMobile}
            />

            <Team
              title='Album boxes'
              description='store your album'
              link='/albums/about/'
              data={data}
              image={"boxesTeam"}
              isMobile={isMobile}
            />
          </div>
        </div>
      </div>

      <div className={pageStyles.sectionWrapper}>
        <div className={pageStyles.section}>
          <div className={indexStyles.infoIcons}>
            <div className={indexStyles.infoIcon}>
              <div>
                <svg viewBox="0 0 1024 1024" width={42}>
                  <path className="path1"
                        d="M874.038 149.962c-96.704-96.704-225.278-149.962-362.038-149.962s-265.334 53.258-362.038 149.962c-96.704 96.704-149.962 225.278-149.962 362.038s53.258 265.334 149.962 362.038c96.704 96.704 225.278 149.962 362.038 149.962s265.334-53.258 362.038-149.962c96.704-96.704 149.962-225.278 149.962-362.038s-53.258-265.334-149.962-362.038zM941.918 346.178c-9.989-17.987-35.050-26.512-67.853-37.661-35.182-11.957-47.608-48.122-61.994-89.997-12.49-36.35-25.398-73.874-56.069-97.238 83.898 52.584 149.733 131.406 185.915 224.896zM798.235 521.757c3.872 34.683 7.875 70.546-35.163 118.874-11.629 13.056-18.44 31.238-25.653 50.49-16.701 44.582-32.486 86.709-99.642 87.325-1.882-2.262-7.242-10.734-11.981-37.533-4.366-24.698-6.886-56.606-9.555-90.389-4.093-51.834-8.731-110.582-21.544-159.32-16.382-62.325-43.867-99.141-84.026-112.554-17.522-5.853-35.411-8.698-54.693-8.698-14.211 0-27.125 1.522-38.517 2.864-8.875 1.045-17.258 2.034-24.341 2.034 0 0-0.002 0-0.003 0-11.987 0-25.573 0-42.278-38.29-24.021-55.053-6.304-143.267 64.202-189.787 38.661-25.509 65.336-36.392 89.2-36.392 19.026 0 39.581 6.622 68.73 22.146 34.418 18.33 61.379 20.68 81.026 20.68 7.789 0 14.85-0.419 21.682-0.826 5.726-0.339 11.134-0.661 16.139-0.661 11.259 0 20.387 1.467 31.088 8.776 19.723 13.472 29.936 43.195 40.747 74.664 16.392 47.715 34.973 101.798 93.941 121.837 7.925 2.693 21.576 7.333 31.216 11.366-8.328 8.608-22.285 21.067-35.92 33.24-8.808 7.862-18.789 16.773-29.851 26.858-31.965 29.133-28.16 63.221-24.803 93.296zM51.25 508.070c5.52 0.992 11.493 2.141 17.605 3.446 28.776 6.141 42.235 11.686 48.117 14.798-2.706 5.277-8.187 13.056-11.81 18.195-12.669 17.976-28.435 40.349-22.437 64.984 4.046 16.618 0.632 37.032-5.248 55.883-16.994-48.005-26.277-99.624-26.277-153.378 0-1.314 0.038-2.618 0.050-3.93zM512 972.8c-175.379 0-328.173-98.494-406.014-243.062 13.422-25.554 38.314-82.054 26.68-131.547 0.806-4.97 9.248-16.95 14.349-24.186 13.874-19.688 31.141-44.189 18.35-70.152-8.976-18.222-32.957-30.534-80.181-41.17-10.939-2.464-21.594-4.47-30.65-6.019 27.424-228.090 222.107-405.464 457.466-405.464 80.776 0 156.749 20.918 222.83 57.582-16.33-7.134-31.154-8.266-43.014-8.266-6.523 0-12.957 0.382-19.176 0.752-6.085 0.362-12.374 0.734-18.645 0.734-14.542 0-32.682-1.742-56.958-14.67-37.056-19.734-64.808-28.155-92.795-28.155-34.635 0-69.744 13.414-117.397 44.856-41.197 27.181-72.229 68.779-87.381 117.133-14.779 47.166-13.2 95.418 4.448 135.867 20.824 47.728 48.336 69.013 89.203 69.014 0.003 0 0.003 0 0.006 0 10.090 0 19.923-1.158 30.333-2.386 10.482-1.235 21.32-2.512 32.525-2.512 13.869 0 26.094 1.926 38.472 6.061 22.488 7.512 39.082 32.701 50.728 77.008 11.648 44.31 16.098 100.638 20.021 150.334 3.274 41.454 6.366 80.61 13.176 110.126 4.136 17.923 9.494 31.538 16.379 41.621 10.283 15.058 25.032 23.35 41.526 23.35 45.269 0 81.429-14.594 107.47-43.374 21.659-23.934 32.722-53.466 41.613-77.194 5.245-14.003 10.67-28.482 15.941-34.402 58.219-65.373 52.203-119.258 47.813-158.603-3.226-28.888-3.285-39.123 8.408-49.781 10.864-9.904 20.741-18.722 29.454-26.499 18.568-16.576 31.984-28.554 41.397-38.83 6.464-7.058 21.603-23.584 17.395-44.28-0.037-0.184-0.088-0.358-0.126-0.539 17.558 48.701 27.154 101.174 27.154 155.851 0 254.086-206.714 460.8-460.8 460.8z"></path>
                </svg>
              </div>
              <div className={indexStyles.infoIconContent}>
                <h4 className={indexStyles.infoIconContentTitle}>Shipping worldwide</h4>
                <div className={indexStyles.infoIconContentText}>free express shipping for every order</div>
              </div>
            </div>


            <div className={indexStyles.infoIcon}>
              <div>
                <svg viewBox="0 0 1024 1024" width={42}>
                  <path className="path1"
                        d="M896.533 229.867c-82.198-82.198-191.488-127.467-307.733-127.467s-225.534 45.269-307.733 127.467-127.467 191.486-127.467 307.733v66.197l-109.899-109.899c-9.997-9.997-26.206-9.997-36.203 0s-9.998 26.206 0 36.203l153.6 153.6c5 5 11.55 7.499 18.102 7.499s13.102-2.499 18.101-7.499l153.6-153.6c9.998-9.997 9.998-26.206 0-36.203s-26.206-9.997-36.203 0l-109.898 109.899v-66.197c0-211.738 172.262-384 384-384 211.739 0 384 172.262 384 384s-172.261 384-384 384c-14.139 0-25.6 11.461-25.6 25.6s11.461 25.6 25.6 25.6c116.245 0 225.534-45.269 307.733-127.467s127.467-191.488 127.467-307.733c0-116.246-45.269-225.534-127.467-307.733z"></path>
                </svg>
              </div>
              <div className={indexStyles.infoIconContent}>
                <h4 className={indexStyles.infoIconContentTitle}>sustainable materials</h4>
                <div className={indexStyles.infoIconContentText}>because we care about the environment</div>
              </div>
            </div>


            <div className={indexStyles.infoIcon}>
              <div>
                <svg viewBox="0 0 1024 1024" width={42}>
                  <path className="path1"
                        d="M512 1024c-7.856 0-15.277-3.606-20.13-9.784-2.931-3.73-72.587-92.864-143.229-224.51-41.581-77.491-74.742-153.568-98.565-226.118-30.043-91.499-45.277-177.758-45.277-256.387 0-169.39 137.81-307.2 307.2-307.2s307.2 137.81 307.2 307.2c0 78.629-15.234 164.888-45.278 256.386-23.822 72.55-56.984 148.629-98.565 226.118-70.64 131.646-140.298 220.781-143.229 224.51-4.851 6.179-12.272 9.786-20.128 9.786zM512 51.2c-141.158 0-256 114.842-256 256 0 166.597 74.914 341.176 137.758 458.296 46.186 86.074 92.634 154.306 118.237 189.938 25.709-35.789 72.429-104.432 118.688-190.76 62.643-116.902 137.317-291.163 137.317-457.474 0-141.158-114.84-256-256-256z"></path>
                  <path className="path2"
                        d="M512 460.8c-84.696 0-153.6-68.904-153.6-153.6s68.904-153.6 153.6-153.6 153.6 68.904 153.6 153.6-68.904 153.6-153.6 153.6zM512 204.8c-56.464 0-102.4 45.936-102.4 102.4s45.936 102.4 102.4 102.4c56.464 0 102.4-45.936 102.4-102.4s-45.936-102.4-102.4-102.4z"></path>
                </svg>
              </div>
              <div className={indexStyles.infoIconContent}>
                <h4 className={indexStyles.infoIconContentTitle}>order tracking</h4>
                <div className={indexStyles.infoIconContentText}>check the progress in real time</div>
              </div>
            </div>

            <div className={indexStyles.infoIcon}>
              <div>
                <svg viewBox="0 0 1024 1024" width={42}>
                  <path className="path1"
                        d="M486.4 1024c-129.922 0-252.067-50.594-343.936-142.464s-142.464-214.014-142.464-343.936c0-129.923 50.595-252.067 142.464-343.936s214.013-142.464 343.936-142.464c129.922 0 252.067 50.595 343.936 142.464s142.464 214.014 142.464 343.936-50.594 252.067-142.464 343.936c-91.869 91.87-214.014 142.464-343.936 142.464zM486.4 102.4c-239.97 0-435.2 195.23-435.2 435.2s195.23 435.2 435.2 435.2 435.2-195.23 435.2-435.2-195.23-435.2-435.2-435.2z"></path>
                  <path className="path2"
                        d="M332.8 409.6c-42.347 0-76.8-34.453-76.8-76.8s34.453-76.8 76.8-76.8 76.8 34.453 76.8 76.8-34.453 76.8-76.8 76.8zM332.8 307.2c-14.115 0-25.6 11.485-25.6 25.6s11.485 25.6 25.6 25.6 25.6-11.485 25.6-25.6-11.485-25.6-25.6-25.6z"></path>
                  <path className="path3"
                        d="M640 409.6c-42.349 0-76.8-34.453-76.8-76.8s34.451-76.8 76.8-76.8 76.8 34.453 76.8 76.8-34.451 76.8-76.8 76.8zM640 307.2c-14.115 0-25.6 11.485-25.6 25.6s11.485 25.6 25.6 25.6 25.6-11.485 25.6-25.6-11.485-25.6-25.6-25.6z"></path>
                  <path className="path4"
                        d="M486.4 870.4c-183.506 0-332.8-149.294-332.8-332.8 0-14.139 11.462-25.6 25.6-25.6s25.6 11.461 25.6 25.6c0 155.275 126.325 281.6 281.6 281.6s281.6-126.325 281.6-281.6c0-14.139 11.461-25.6 25.6-25.6s25.6 11.461 25.6 25.6c0 183.506-149.294 332.8-332.8 332.8z"></path>
                </svg>
              </div>
              <div className={indexStyles.infoIconContent}>
                <h4 className={indexStyles.infoIconContentTitle}>outstanding customer service</h4>
                <div className={indexStyles.infoIconContentText}>we're always here to help</div>
              </div>
            </div>
          </div>


        </div>
      </div>

      <div className={pageStyles.sectionWrapper}>
        <div className={pageStyles.section}>
          <div className={indexStyles.videoWrapper}>
            <div className={indexStyles.videoLeft}>
              <div className={indexStyles.videoLeftContent}>
                <h2 className={indexStyles.videoLeftContentTitle}>Made by hand <br/> with heart</h2>
                <div className={indexStyles.videoLeftContentDescription}>
                  We take pride in what we do. Find out more about our process.
                  <br/>
                  <br/>
                  <br/>
                  <Link to={'/about/'} className={buttonStyles.pink}>
                    Read more
                  </Link>
                </div>
              </div>
            </div>
            <div className={indexStyles.videoRight}>
              <React.Fragment>
                <div role='button' tabIndex={0} onKeyDown={() => setVideoVisible(true)} onClick={() => setVideoVisible(true)}>
                <Img className={indexStyles.videoRightContent} objectFit="contain"
                     fluid={data.videoHomepage.childImageSharp.fluid}/>
                </div>
                <ModalVideo channel='vimeo' autoplay isOpen={videoVisible} videoId="147668104"
                            onClose={() => setVideoVisible(false)}/>
              </React.Fragment>
            </div>
          </div>
        </div>
      </div>

    </Page>
  )
}

export const query = graphql`
  query {
  albumsTeam: file(relativePath: { eq: "albumsTeam.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 620, quality: 80) {
          ...GatsbyImageSharpFluid_withWebp_tracedSVG
        }
      }
    }
   guestbooksTeam: file(relativePath: { eq: "guestbooksTeam.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 620, quality: 80) {
          ...GatsbyImageSharpFluid_withWebp_tracedSVG
        }
      }
    }
    boxesTeam: file(relativePath: { eq: "boxesTeam.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 620, quality: 80) {
          ...GatsbyImageSharpFluid_withWebp_tracedSVG
        }
      }
    }
    childrenTeam: file(relativePath: { eq: "childrenTeam.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 620, quality: 80) {
          ...GatsbyImageSharpFluid_withWebp_tracedSVG
        }
      }
    }
    videoHomepage: file(relativePath: { eq: "videoHomepage.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 650, quality: 80) {
          ...GatsbyImageSharpFluid_withWebp_tracedSVG
        }
      }
    }
  }
`